export const TERMS_AND_CONDITIONS_LINK = 'https://support.wix.com/en/article/wix-payments-terms-of-service';
export const APP_MARKET_TERMS_LINK = 'https://www.wix.com/about/app-market-terms';
export const MODALYST_TERMS_LINK = 'https://www.modalyst.co/terms/';
export const MODALYST_PRIVACY_POLICY = 'https://www.modalyst.co/privacy/';
export const SERVICE_FEES_LINK = 'https://support.wix.com/en/article/wix-payments-service-fees';
